import { computed } from "vue";

import { useTheme } from "vuetify/lib/framework.mjs";

export default class GuestLayoutViewModel {
  private theme = useTheme();
  public appName = process.env.VUE_APP_APP_NAME || "";

  public isDarkMode = computed({
    get: () => this.theme.global.name.value === "dark",
    set: (value: string) => {
      //console.log(value);
      const newTheme =
        this.theme.global.name.value === "dark" ? "light" : "dark";
      this.theme.global.name.value = newTheme;

      // Guardar el tema seleccionado en localStorage
      localStorage.setItem("theme", newTheme);
    },
  });
  constructor() {
    const systemPrefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    const defaultTheme = systemPrefersDark ? "dark" : "light";

    // Crear una referencia para almacenar el tema
    const savedTheme = localStorage.getItem("theme") || defaultTheme;

    if (savedTheme) {
      this.theme.global.name.value = savedTheme;
    }
  }
}
